import styles from './PlanCardDescription.module.scss';
import { usePaymentControlState } from 'src/hooks';
import { CanonicalInterval, PaymentTabs } from 'src/types';
import { Button } from 'src/v2/commonComponents/Button';
import { setIsShowRequestUsageTable, useAppDispatch } from 'src/store';
import { SUPER_PROJECT_NAME, SVG_SIZE_S } from 'src/constants';
import { Info } from '@phosphor-icons/react';
import { ProgressBar } from 'src/components/FlatAppearance/components/ThreadCombinedCard/components/ProgressBar';

type PlanCardDescriptionProps = {
  totalRequests: number;
  isEntitlementLoading: boolean;
};

export const PlanCardDescription = ({
  totalRequests,
}: PlanCardDescriptionProps) => {
  const { selectedPaymentTab, selectedPeriod } = usePaymentControlState();
  const dispatch = useAppDispatch();

  const handleOpenModalClick = () => {
    dispatch(
      setIsShowRequestUsageTable(
        selectedPaymentTab === PaymentTabs.INDIVIDUAL
          ? 'individual'
          : 'business',
      ),
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.leftSideWrapper}>
        <div className={styles.leftSideTitle}>
          <h5 className={styles.accentTitle}>{SUPER_PROJECT_NAME} Agent</h5>
          <Button
            color="transparent"
            onClick={handleOpenModalClick}
            className={styles.infoButton}
          >
            <Info size={SVG_SIZE_S} className={styles.infoIcon} />
          </Button>
        </div>
        <span className={styles.leftSideDescription}>
          AI agent with its own computer for research, build & deploy
        </span>
      </div>
      {totalRequests === 0 ? (
        <div className={styles.loaderWrapper}>
          <ProgressBar />
        </div>
      ) : (
        <span className={styles.totalRequests}>
          {totalRequests === -1 ? 'Unlimited' : totalRequests}
          {totalRequests === -1
            ? ''
            : ` tasks/${selectedPeriod === CanonicalInterval.ANNUALLY ? 'yr' : 'mo'}`}
        </span>
      )}
    </div>
  );
};
